import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import '../styles/AdminInpost.css';
import ButtonRegular from './ui/ButtonRegular';

const AdminInpost = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const apiUrl = process.env.REACT_APP_API_URL || '';
	const stateOrder = location.state?.order || null;
	const [order, setOrder] = useState(stateOrder);
	const [loading, setLoading] = useState(!stateOrder);
	const [error, setError] = useState('');
	const [successMsg, setSuccessMsg] = useState('');

	const [parcel, setParcel] = useState({
		weight: '',
		length: '',
		width: '',
		height: '',
	});


	const handleChange = (e) => {
		const { name, value } = e.target;
		setParcel(prev => ({ ...prev, [name]: value }));
	};

const handleSendToInpost = async () => {
	setError('');
	setSuccessMsg('');

	if (!parcel.weight || !parcel.length || !parcel.width || !parcel.height) {
		return setError('Uzupełnij dane paczki.');
	}

	try {
		if (!order?.clientAddress) {
			return setError('Brak danych klienta.');
		}

		const sender = {
			company_name: "Kwiaty z gór",
			first_name: "Ewa",
			last_name: "Rapta",
			email: "kontakt@kwiatyzgor.pl",
			phone: "792 825 301",
			address: {
				street: "Raba Niżna",
				building_number: "165",
				city: "Raba Niżna",
				post_code: "34-730",
				country_code: "PL"
			}
		};

		const receiver = {
            company_name: order.invoice?.companyName,
			first_name: order.clientAddress.firstName,
			last_name: order.clientAddress.lastName,
			email: order.user?.email,
			phone: order.clientAddress.phone,
			address: {
				street: order.shippingAddress.street,
				building_number: order.shippingAddress.building + ' / ' + order.shippingAddress.apartment,
				city: order.shippingAddress.city,
				post_code: order.shippingAddress.postalCode,
				country_code: 'PL',
			}
		};

		const parcels = [
			{
				id: order.orderNumber,
				dimensions: {
					length: Number(parcel.length) * 10,
					width: Number(parcel.width) * 10,
					height: Number(parcel.height) * 10,
					unit: "mm"
				},
				weight: {
					amount: Number(parcel.weight),
					unit: "kg"
				},
				is_non_standard: false
			}
		];

		const shipmentData = {
			sender,
			receiver,
			parcels,
            insurance: {
                amount: Number(order.total),
                currency: "PLN"
            },
			service: "inpost_courier_standard",
			reference: 'Zamówienie ' + (order.orderNumber),
			orderId: order.orderNumber
		};

		console.log('📦 FULL SHIPMENT:', shipmentData);

		const res = await axios.post(`${apiUrl}/api/shipments/inpostCourier`, shipmentData);

		setSuccessMsg(res.data.message || 'Nadano');
	} catch (err) {
		console.error('❌ Błąd:', err.response?.data || err.message);
		setError(err.response?.data?.message || 'Błąd zapisu.');
	}
};

	if (loading) return <p>Ładowanie...</p>;
	if (error && !order) return <p className="error-text">{error}</p>;
	if (!order) return <p>Brak zamówienia</p>;

	const items = order.items || [];
	const total = order.total || 0;

	return (
		<div className="form-container">
			<div className="form-content">

				<h1 className="form-title">Wysyłka InPost</h1>
				<h3 className="form-subtitle">
					Zamówienie: {order.orderNumber || order._id}
				</h3>

				{/* 📦 Produkty */}
				<section className="form-section">
					<h2>Produkty</h2>
					<table className="products-table">
						<thead>
							<tr>
								<th style={{ color: 'white' }}>#</th>
								<th style={{ color: 'white' }}>Nazwa</th>
								<th style={{ color: 'white' }}>Ilość</th>
								<th style={{ textAlign: 'right', color: 'white' }}>Cena</th>
							</tr>
						</thead>
<tbody>
	{items.map((item, i) => {
		const name = item.product?.name || 'Brak nazwy';
		const quantity = item.quantity || 0;
		const price = item.product?.price || item.price || 0;

		return (
			<tr key={i}>
				<td>{i + 1}</td>
				<td>{name}</td>
				<td>{quantity}</td>
				<td style={{ textAlign: 'right' }}>
					{(price * quantity).toFixed(2)} PLN
				</td>
			</tr>
		);
	})}
    <tr>
        <td colSpan={1} style={{ fontWeight: 'bold' }}>Wysyłka:</td>
        <td colSpan={2} style={{ textAlign: 'left', fontWeight: 'bold' }}>
            {order.delivery?.method}
        </td>        
        <td style={{ textAlign: 'right', fontWeight: 'bold' }}>
            {order.delivery?.price.toFixed(2) + ' PLN'}
        </td>
    </tr>
	<tr>
		<td colSpan={3}>Razem</td>
		<td style={{ textAlign: 'right' }}>
			{total.toFixed(2)} PLN
		</td>
	</tr>
</tbody>
					</table>
				</section>

				{/* 👤 Dane klienta */}
				<section className="form-section">
					<h2>Klient</h2>
					<p>Imię: {order.clientAddress.firstName} </p>
                    <p>Nazwisko: {order.clientAddress.lastName}</p>
                    {order.invoice?.companyName && (
                        <p>Firma: {order.invoice.companyName}</p>
                    )}
					<p>Telefon: {order.clientAddress.phone}</p>
					<p>Email: {order.user?.email}</p>
				</section>

                <section className="form-section">
					<h2>Dane wysyłki</h2>
					<p>Kod pocztowy: {order.shippingAddress.postalCode}</p>
                    <p>Miasto: {order.shippingAddress.city}</p>
					<p>Ulica: {order.shippingAddress.street}</p>
					<p>Budynek: {order.shippingAddress.building}</p>
                    {order.shippingAddress?.apartment && (
                        <p>Mieszkanie: {order.shippingAddress.apartment}</p>
                    )}
				</section>

				{/* 📦 Dane paczki */}
				<section className="form-section">
					<h2>Dane paczki</h2>

					<input type="number" placeholder="Waga (kg)" name="weight" value={parcel.weight} onChange={handleChange} />
					<input type="number" placeholder="Długość (cm)" name="length" value={parcel.length} onChange={handleChange} />
					<input type="number" placeholder="Szerokość (cm)" name="width" value={parcel.width} onChange={handleChange} />
					<input type="number" placeholder="Wysokość (cm)" name="height" value={parcel.height} onChange={handleChange} />

					<ButtonRegular onClick={handleSendToInpost}>
						Wyślij do InPost
					</ButtonRegular>

					{successMsg && <p className="success-text">{successMsg}</p>}
					{error && <p className="error-text">{error}</p>}
				</section>

				<ButtonRegular onClick={() => navigate(-1)}>
					Powrót
				</ButtonRegular>

			</div>
		</div>
	);
};

export default AdminInpost;